import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import {
  SSO_REDIRECT_URL_REQUIRED_MESSAGE,
  validateSsoRedirectUrl,
} from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/utils/SSO.utils';

export interface SSORedirectUrlControlProps {
  name: string;
  id: string;
}

export function SSORedirectUrlControl({
  name,
  id,
}: SSORedirectUrlControlProps): JSX.Element {
  const { control, errors } = useFormContext();

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      aria-label={name}
      inputSize="medium"
      blockWidth
      label="Company's IdP url *"
      rules={{
        required: SSO_REDIRECT_URL_REQUIRED_MESSAGE,
        validate: {
          validateSsoRedirectUrl,
        },
      }}
    />
  );
}
